/* 韩语 */
import koLocale from 'element-ui/lib/locale/lang/ko'
const ko = {
  message: {
    hello: '중국어'
  },
  ...koLocale
}

export default ko



// WEBPACK FOOTER //
// ./src/components/common/langs/ko.js